module.exports = "/images/jpg-fileicon.svg?9f5ede72aedd1c8b21e30d9e62de94e7";